import { CSSProperties, FC } from "react";
import { Textbox } from "capitalrx-components-2.0/lib/forms";
import { useEnrollmentContext } from "@/state";
import "./ThemedTextBox.scss";

export const ThemedTextBox: FC<React.ComponentProps<typeof Textbox> & { $isError?: boolean }> = (props) => {
  const { $isError, className, style, ...textboxProps } = props;
  const experienceData = useEnrollmentContext();
  const primaryColor = experienceData?.theme?.primary_color || "#00a4e4";

  const themedStyle: CSSProperties = {
    ...(style || {}),
    ["--themed-textbox-focus-color" as string]: primaryColor,
  };
  const themedClass = ["premium-themed-textbox", $isError ? "premium-themed-textbox-error" : "", className].filter(Boolean).join(" ");

  return <Textbox {...textboxProps} className={themedClass} style={themedStyle} />;
};
